<section class="max-w-[1200px] mx-auto px-6 lg:px-10 py-10 animate-fade-in relative z-10">

  <!-- Header & Breadcrumb -->
  <div class="flex flex-col md:flex-row md:items-start justify-between mb-8 gap-4">
    <div>
      <div class="flex items-center text-[13px] text-text-muted font-bold mb-3">
        <button (click)="goBack()" class="hover:text-white transition-colors">Your positions</button>
        <svg class="w-3.5 h-3.5 mx-2 text-text-dim" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
        </svg>
        <span class="text-white">New position</span>
      </div>
      <h1 class="font-display font-black text-[32px] md:text-[40px] text-white tracking-wide">New position</h1>
    </div>

    <div class="flex flex-wrap items-center gap-3 mt-4 md:mt-0">
      <button (click)="resetForm()"
        class="flex items-center gap-2 border border-white/10 hover:border-white/30 hover:bg-white/5 text-white font-bold py-2.5 px-4 rounded-lg transition-all text-[13.5px] whitespace-nowrap">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15">
          </path>
        </svg>
        Reset
      </button>
    </div>
  </div>

  <div class="flex flex-col min-[1024px]:flex-row items-start gap-8">

    <!-- Left Sidebar: Progress Tracker -->
    <div class="w-full min-[1024px]:w-[28%] shrink-0">
      <div
        class="bg-[#0c0c0c]/80 border border-white/[0.08] shadow-[0_12px_45px_rgba(0,0,0,0.6)] rounded-2xl p-8 backdrop-blur-xl h-fit relative">

        <!-- Step 1 -->
        <div class="relative flex items-start gap-5" [class.opacity-50]="activeStep === 2">
          <div class="flex flex-col items-center mt-0.5">
            <div class="w-6 h-6 rounded-full flex items-center justify-center font-bold text-[11px]"
              [ngClass]="activeStep === 1 ? 'bg-gold text-black shadow-[0_0_10px_rgba(245,183,59,0.5)]' : 'bg-gold text-black'">
              <ng-container *ngIf="activeStep === 2">
                <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </ng-container>
              <ng-container *ngIf="activeStep === 1">1</ng-container>
            </div>
            <div class="w-px h-20 bg-white/10 my-2"></div>
          </div>
          <div>
            <div class="text-[12px] font-bold mb-1" [ngClass]="activeStep === 1 ? 'text-gold' : 'text-text-muted'">Step
              1</div>
            <div class="text-[15px] font-bold text-white mb-2 leading-tight">Select token pair and fees</div>

            <div *ngIf="activeStep === 2"
              class="text-[13px] text-white font-bold bg-white/5 border border-white/10 px-3 py-1.5 rounded-lg inline-flex items-center gap-2 mt-1">
              {{state.fromToken().symbol}} / {{state.toToken()?.symbol || '...'}} <span
                class="w-1 h-1 rounded-full bg-text-dim"></span> {{selectedFeeTier}}
            </div>
            <div *ngIf="activeStep === 1" class="text-[13px] text-text-muted leading-relaxed">Choose a token pair and
              fee tier for your liquidity position.</div>
          </div>
        </div>

        <!-- Step 2 -->
        <div class="relative flex items-start gap-5">
          <div class="flex flex-col items-center mt-0.5">
            <div class="w-6 h-6 rounded-full flex items-center justify-center font-bold text-[11px]"
              [ngClass]="activeStep === 2 ? 'bg-gold text-black shadow-[0_0_10px_rgba(245,183,59,0.5)]' : 'bg-white/10 text-text-dim border border-white/10'">
              2</div>
          </div>
          <div>
            <div class="text-[12px] font-bold mb-1" [ngClass]="activeStep === 2 ? 'text-gold' : 'text-text-muted'">Step
              2</div>
            <div class="text-[15px] font-bold mb-2 leading-tight"
              [ngClass]="activeStep === 2 ? 'text-white' : 'text-text-muted'">Set price range and deposit amounts</div>
            <div *ngIf="activeStep === 2" class="text-[13px] text-text-muted leading-relaxed">Set your price range and
              deposit amounts.</div>
          </div>
        </div>

      </div>
    </div>

    <!-- Right Panel: Dynamic Content -->

    <!-- Auto-Navigating Loader -->
    <div *ngIf="activeStep === 1 && isAutoNavigating"
      class="flex-1 bg-[#0c0c0c]/80 border border-white/[0.08] shadow-[0_12px_45px_rgba(0,0,0,0.6)] rounded-2xl p-16 flex flex-col items-center justify-center backdrop-blur-xl min-h-[400px]">
       <svg class="animate-spin h-10 w-10 text-gold mb-4" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
       </svg>
       <p class="text-white font-bold text-[16px] tracking-wide animate-pulse">Loading pool data...</p>
       <p class="text-text-muted text-[13px] mt-2">Setting up your position parameters.</p>
    </div>

    <!-- STEP 1 CONTENT -->
    <div *ngIf="activeStep === 1 && !isAutoNavigating"
      class="flex-1 bg-[#0c0c0c]/80 border border-white/[0.08] shadow-[0_12px_45px_rgba(0,0,0,0.6)] rounded-2xl p-8 backdrop-blur-xl">

      <h2 class="text-white text-[18px] font-bold mb-2">Select token pair</h2>
      <p class="text-text-muted text-[13.5px] mb-6">Choose the tokens you want to provide liquidity for.</p>

      <div class="flex flex-col sm:flex-row items-center gap-4 mb-10">
        <!-- Token 1 -->
        <button (click)="openLocalModal('from')"
          class="w-full sm:flex-1 min-w-[240px] flex items-center justify-between border border-white/[0.08] rounded-xl p-3 hover:bg-white/[0.03] transition-colors bg-[#050505]">
          <div class="flex items-center gap-3">
            <div
              class="w-9 h-9 rounded-full flex items-center justify-center font-bold text-white border-2 border-black shadow-sm overflow-hidden"
              [style.backgroundColor]="state.fromToken().color">
              <img *ngIf="state.fromToken().logoUrl" [src]="state.fromToken().logoUrl" class="w-full h-full object-cover">
              <span *ngIf="!state.fromToken().logoUrl">{{state.fromToken().symbol.charAt(0)}}</span>
            </div>
            <div class="text-left">
              <div class="text-white font-bold text-[15px]">{{state.fromToken().symbol}}</div>
              <div class="text-text-muted text-[12px]">{{state.fromToken().name}}</div>
            </div>
          </div>
          <svg class="w-4 h-4 text-text-dim" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        <!-- Swap Icon -->
        <button (click)="swapTokens()"
          class="w-10 h-10 rounded-xl border border-white/[0.08] flex items-center justify-center text-text-muted hover:text-white hover:border-white/30 transition-colors bg-[#050505] shrink-0 rotate-90 sm:rotate-0">
          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
          </svg>
        </button>

        <!-- Token 2 -->
        <button (click)="openLocalModal('to')"
          class="w-full sm:flex-1 min-w-[240px] flex items-center justify-between border border-white/[0.08] rounded-xl p-3 hover:bg-white/[0.03] transition-colors bg-[#050505]">
          <div class="flex items-center gap-3">
            <div *ngIf="state.toToken()"
              class="w-9 h-9 rounded-full flex items-center justify-center font-bold text-white border-2 border-black shadow-sm overflow-hidden"
              [style.backgroundColor]="state.toToken()?.color">
              <img *ngIf="state.toToken()?.logoUrl" [src]="state.toToken()?.logoUrl" class="w-full h-full object-cover">
              <span *ngIf="!state.toToken()?.logoUrl">{{state.toToken()?.symbol?.charAt(0)}}</span>
            </div>
            <div *ngIf="!state.toToken()"
              class="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center font-bold text-text-muted border-2 border-black shadow-sm">
              ?
            </div>
            <div class="text-left">
              <div class="text-white font-bold text-[15px]">{{state.toToken()?.symbol || 'Select Token'}}</div>
              <div class="text-text-muted text-[12px]">{{state.toToken()?.name || 'Choose a token'}}</div>
            </div>
          </div>
          <svg class="w-4 h-4 text-text-dim" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </button>
      </div>

      <ng-container *ngIf="state.fromToken() && state.toToken()">
        <h2 class="text-white text-[18px] font-bold mb-2">Fee tier</h2>
        <p class="text-text-muted text-[13.5px] mb-5">The amount earned providing liquidity. Choose a fee tier that
          suits
          your risk tolerance and strategy.</p>

        <div class="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
          <button *ngIf="availableFeeTiers.includes(500)" (click)="selectFeeTier('0.05%')"
            [class.border-gold]="selectedFeeTier === '0.05%'"
            class="p-4 border border-white/[0.08] rounded-xl text-left hover:border-white/30 transition-all bg-[#050505]"
            [class.bg-gold/5]="selectedFeeTier === '0.05%'">
            <div class="font-bold text-[17px] mb-1.5" [class.text-gold]="selectedFeeTier === '0.05%'"
              [class.text-white]="selectedFeeTier !== '0.05%'">0.05%</div>
            <div class="text-text-muted text-[11.5px] leading-tight">Best for most pairs</div>
          </button>
          <button *ngIf="availableFeeTiers.includes(3000)" (click)="selectFeeTier('0.30%')"
            [class.border-gold]="selectedFeeTier === '0.30%'"
            class="p-4 border border-white/[0.08] rounded-xl text-left hover:border-white/30 transition-all bg-[#050505]"
            [class.bg-gold/5]="selectedFeeTier === '0.30%'">
            <div class="font-bold text-[17px] mb-1.5" [class.text-gold]="selectedFeeTier === '0.30%'"
              [class.text-white]="selectedFeeTier !== '0.30%'">0.30%</div>
            <div class="text-text-muted text-[11.5px] leading-tight">Best for exotic pairs</div>
          </button>
          <button *ngIf="availableFeeTiers.includes(10000)" (click)="selectFeeTier('1.00%')"
            [class.border-gold]="selectedFeeTier === '1.00%'"
            class="p-4 border border-white/[0.08] rounded-xl text-left hover:border-white/30 transition-all bg-[#050505]"
            [class.bg-gold/5]="selectedFeeTier === '1.00%'">
            <div class="font-bold text-[17px] mb-1.5" [class.text-gold]="selectedFeeTier === '1.00%'"
              [class.text-white]="selectedFeeTier !== '1.00%'">1.00%</div>
            <div class="text-text-muted text-[11.5px] leading-tight">Best for very exotic pairs</div>
          </button>
        </div>

        <div class="p-4 border border-white/[0.05] rounded-xl bg-white/[0.02] flex items-start gap-3 mb-8"
          *ngIf="selectedFeeTier">
          <svg class="w-5 h-5 text-gold mt-0.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"
            stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
          </svg>
          <div>
            <div class="text-white font-bold text-[14px] mb-1">{{selectedFeeTier}} fee tier selected</div>
            <div class="text-text-muted text-[13.5px]">You will earn {{selectedFeeTier}} in fees for swaps within your
              selected price range.</div>
          </div>
        </div>
      </ng-container>

      <button (click)="goToStep2()" class="w-full btn-gold py-4 rounded-xl font-bold text-[15.5px]"
        [disabled]="!state.toToken() || !selectedFeeTier"
        [class.opacity-50]="!state.toToken() || !selectedFeeTier">Continue</button>
    </div>

    <!-- STEP 2 CONTENT -->
    <div *ngIf="activeStep === 2"
      class="flex-1 bg-[#0c0c0c]/80 border border-white/[0.08] shadow-[0_12px_45px_rgba(0,0,0,0.6)] rounded-2xl p-8 backdrop-blur-xl">

      <!-- Header -->
      <div class="flex items-center justify-between mb-8 pb-5 border-b border-white/[0.05]">
        <div class="flex items-center gap-3">
          <div class="flex -space-x-2.5">
            <div
              class="w-8 h-8 rounded-full flex items-center justify-center text-[10px] font-bold text-white border-2 border-black z-10 shadow-sm overflow-hidden"
              [style.backgroundColor]="state.fromToken().color">
              <img *ngIf="state.fromToken().logoUrl" [src]="state.fromToken().logoUrl" class="w-full h-full object-cover">
              <span *ngIf="!state.fromToken().logoUrl">{{state.fromToken().symbol.charAt(0)}}</span>
            </div>
            <div *ngIf="state.toToken()"
              class="w-8 h-8 rounded-full flex items-center justify-center text-[10px] font-bold text-white border-2 border-black shadow-sm overflow-hidden"
              [style.backgroundColor]="state.toToken()?.color">
              <img *ngIf="state.toToken()?.logoUrl" [src]="state.toToken()?.logoUrl" class="w-full h-full object-cover">
              <span *ngIf="!state.toToken()?.logoUrl">{{state.toToken()?.symbol?.charAt(0)}}</span>
            </div>
          </div>
          <div class="text-white font-bold text-[18px]">{{state.fromToken().symbol}} / {{state.toToken()?.symbol ||
            '...'}} <span
              class="ml-2 px-1.5 py-0.5 bg-gold/10 border border-gold/20 text-gold text-[12px] font-extrabold rounded-md">{{selectedFeeTier}}</span>
          </div>
        </div>
        <button (click)="editPair()"
          class="flex items-center gap-2 border border-white/10 px-3 py-1.5 rounded-lg text-text-muted hover:text-white text-[12px] font-bold hover:border-white/30 transition-colors">
          <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
          </svg>
          Edit pair
        </button>
      </div>

      <h2 class="text-white text-[16.5px] font-bold mb-4">Set price range</h2>

      <!-- Range Toggle -->
      <div class="flex border border-white/[0.08] rounded-xl mb-4 p-1 bg-white/[0.02]">
        <button (click)="setRangeMode('full')"
          [ngClass]="rangeMode === 'full' ? 'bg-white/10 text-white shadow-sm border-white/5' : 'text-text-muted hover:text-white border-transparent'"
          class="flex-1 py-2 text-[13.5px] font-bold rounded-lg border transition-all">Full range</button>
        <button (click)="setRangeMode('custom')"
          [ngClass]="rangeMode === 'custom' ? 'bg-white/10 text-white shadow-sm border-white/5' : 'text-text-muted hover:text-white border-transparent'"
          class="flex-1 py-2 text-[13.5px] font-bold rounded-lg border transition-all">Custom range</button>
      </div>

      <p class="text-text-muted text-[13px] mb-7 leading-relaxed h-10">
        <span *ngIf="rangeMode === 'custom'">Custom range allows you to concentrate your liquidity within specific price
          bounds, enhancing capital efficiency and fee earnings but requiring more active management.</span>
        <span *ngIf="rangeMode === 'full'">Full range allows you to provide liquidity across all prices, requiring less
          management but lowering capital efficiency.</span>
      </p>

      <!-- Chart Area -->
      <div class="mb-6 border-b border-white/[0.05] pb-6">
        <div class="flex flex-col sm:flex-row sm:items-end justify-between mb-4 gap-4">
          <div>
            <div class="text-[12.5px] font-bold text-text-muted mb-1">Current price</div>
            <div class="text-[24px] font-black text-white leading-tight flex flex-wrap items-baseline gap-x-1.5">
              <span *ngIf="!isCalculatingRange">{{formatSubscript(currentPrice)}}</span>
              <span *ngIf="isCalculatingRange" class="w-24 h-7 bg-white/10 animate-pulse rounded"></span>
              <span class="text-[14px] font-bold text-text-muted"><ng-container
                  *ngIf="baseToken === 'from'">{{state.toToken()?.symbol || '...'}} per
                  {{state.fromToken().symbol}}</ng-container><ng-container
                  *ngIf="baseToken === 'to'">{{state.fromToken().symbol}} per {{state.toToken()?.symbol ||
                  '...'}}</ng-container></span>
            </div>
          </div>
          <div
            class="flex border border-white/[0.08] rounded-[10px] overflow-hidden bg-white/[0.02] p-0.5 shadow-inner w-full sm:w-auto">
            <button (click)="toggleBaseToken('from')"
              [ngClass]="baseToken === 'from' ? 'text-white bg-white/10 border-white/[0.05]' : 'text-text-muted hover:text-white border-transparent'"
              class="flex-1 sm:flex-none justify-center flex items-center gap-1.5 px-3 py-1.5 text-[12.5px] font-bold rounded-[8px] border transition-colors">
              <div class="w-4 h-4 rounded-full flex items-center justify-center text-[8px] border border-[#0c0c0c] overflow-hidden"
                [style.backgroundColor]="state.fromToken().color">
                <img *ngIf="state.fromToken().logoUrl" [src]="state.fromToken().logoUrl" class="w-full h-full object-cover">
                <span *ngIf="!state.fromToken().logoUrl">{{state.fromToken().symbol.charAt(0)}}</span>
              </div>
              {{state.fromToken().symbol}}
            </button>
            <button *ngIf="state.toToken()" (click)="toggleBaseToken('to')"
              [ngClass]="baseToken === 'to' ? 'text-white bg-white/10 border-white/[0.05]' : 'text-text-muted hover:text-white border-transparent'"
              class="flex-1 sm:flex-none justify-center flex items-center gap-1.5 px-3 py-1.5 text-[12.5px] font-bold rounded-[8px] border transition-colors">
              <div class="w-4 h-4 rounded-full flex items-center justify-center text-[8px] border border-[#0c0c0c] overflow-hidden"
                [style.backgroundColor]="state.toToken()?.color">
                <img *ngIf="state.toToken()?.logoUrl" [src]="state.toToken()?.logoUrl" class="w-full h-full object-cover">
                <span *ngIf="!state.toToken()?.logoUrl">{{state.toToken()?.symbol?.charAt(0)}}</span>
              </div>
              {{state.toToken()?.symbol}}
            </button>
          </div>
        </div>

        <div class="relative w-full h-[320px] my-4">
          <div *ngIf="isChartLoading" class="absolute inset-0 z-10 flex items-center justify-center bg-[#080808]/80 backdrop-blur-sm rounded-lg">
            <div class="flex flex-col items-center gap-2">
              <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-gold"></div>
              <span class="text-[12px] font-bold text-gold">Loading data...</span>
            </div>
          </div>
          <div #chartContainer class="absolute inset-0" [class.opacity-0]="isChartLoading"></div>
          
          <!-- Native HTML Drag Handles -->
          <div *ngIf="minHandleLeft !== null"
               class="absolute top-[50px] bottom-[50px] w-[40px] -ml-[20px] flex items-center justify-center cursor-ew-resize z-20 group"
               [style.left.px]="minHandleLeft"
               (mousedown)="startHtmlDrag($event, 'min')"
               (touchstart)="startHtmlDrag($event, 'min')">
            <!-- Vertical Line -->
            <div class="absolute top-0 bottom-0 w-[2px] bg-blue-500 shadow-[0_0_10px_rgba(59,130,246,0.8)] group-hover:bg-blue-400 group-hover:w-[3px] transition-all"></div>
            <!-- Grabber Box -->
            <div class="relative w-[20px] h-[40px] bg-[#0f172a] rounded-md flex flex-col items-center justify-center gap-[3px] shadow-lg border-2 border-blue-500 transition-transform group-hover:scale-110 z-10">
              <div class="w-[2px] h-[16px] bg-blue-400 rounded-full"></div>
            </div>
          </div>

          <div *ngIf="maxHandleLeft !== null"
               class="absolute top-[50px] bottom-[50px] w-[40px] -ml-[20px] flex items-center justify-center cursor-ew-resize z-20 group"
               [style.left.px]="maxHandleLeft"
               (mousedown)="startHtmlDrag($event, 'max')"
               (touchstart)="startHtmlDrag($event, 'max')">
            <!-- Vertical Line -->
            <div class="absolute top-0 bottom-0 w-[2px] bg-emerald-500 shadow-[0_0_10px_rgba(16,185,129,0.8)] group-hover:bg-emerald-400 group-hover:w-[3px] transition-all"></div>
            <!-- Grabber Box -->
            <div class="relative w-[20px] h-[40px] bg-[#0f172a] rounded-md flex flex-col items-center justify-center gap-[3px] shadow-lg border-2 border-emerald-500 transition-transform group-hover:scale-110 z-10">
              <div class="w-[2px] h-[16px] bg-emerald-400 rounded-full"></div>
            </div>
          </div>
        </div>

        <!-- Chart controls -->
        <div class="flex flex-col sm:flex-row sm:items-center justify-end mt-4 gap-4">
          <div class="flex items-center gap-1.5 overflow-x-auto hide-scrollbar flex-1">
            <button *ngFor="let tf of timeframes" (click)="selectTimeframe(tf)"
              [class.bg-white]="activeTimeframe === tf" [class.text-black]="activeTimeframe === tf"
              [class.bg-transparent]="activeTimeframe !== tf" [class.text-text-muted]="activeTimeframe !== tf"
              class="px-3.5 py-1.5 rounded-full text-[11.5px] font-bold transition-all duration-200 border border-white/[0.08] hover:border-white/20 whitespace-nowrap">
              {{tf}}
            </button>
          </div>
          <div class="flex items-center justify-end gap-3 w-full sm:w-auto">
            <div class="flex border border-white/[0.08] rounded-md p-0.5 bg-white/[0.02]">
              <button (click)="zoomChart('in')"
                class="w-8 h-8 flex items-center justify-center text-text-muted hover:text-white hover:bg-white/5 rounded transition-colors"><svg
                  class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                </svg></button>
              <button (click)="zoomChart('out')"
                class="w-8 h-8 flex items-center justify-center text-text-muted hover:text-white hover:bg-white/5 rounded transition-colors"><svg
                  class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM13 10H7" />
                </svg></button>
            </div>
            <button (click)="resetZoom()"
              class="px-4 py-1.5 border border-white/[0.08] bg-white/[0.02] rounded-md text-[11.5px] font-bold text-text-muted hover:text-white transition-colors h-8">Reset</button>
          </div>
        </div>
      </div>



      <!-- Min/Max Inputs -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
        <!-- Min Price -->
        <div
          class="border border-white/[0.08] rounded-[16px] p-5 bg-[#050505] focus-within:border-gold/30 transition-colors">
          <div class="flex items-center justify-between">
            <div class="flex-1">
              <div class="text-[12px] font-bold text-text-muted mb-2">Min price</div>
              <div class="mb-0.5">
                <input *ngIf="!isCalculatingRange" type="text" inputmode="decimal" [ngModel]="formatPlain(minPrice)" (ngModelChange)="minPrice = $event; onMinPriceChange()" (keydown)="preventInvalidKeys($event)" (blur)="snapMinPrice()"
                  (wheel)="preventScroll($event)"
                  class="bg-transparent text-[22px] font-black text-white outline-none w-full appearance-none">
                <div *ngIf="isCalculatingRange" class="w-2/3 h-8 bg-white/10 animate-pulse rounded mt-1 mb-1"></div>
              </div>
              <div class="text-[12px] font-bold text-text-muted mb-1.5"><ng-container
                  *ngIf="baseToken === 'from'">{{state.toToken()?.symbol || '...'}} per
                  {{state.fromToken().symbol}}</ng-container><ng-container
                  *ngIf="baseToken === 'to'">{{state.fromToken().symbol}} per {{state.toToken()?.symbol ||
                  '...'}}</ng-container></div>
              <div class="text-[11px] font-bold text-red-400">-10.25%</div>
            </div>
            <div class="flex flex-col gap-2 shrink-0">
              <button (click)="decrementMin()"
                class="w-8 h-8 rounded-lg border border-white/[0.08] bg-white/[0.02] flex items-center justify-center text-text-muted hover:text-white hover:border-white/20 transition-colors"><svg
                  class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M20 12H4" />
                </svg></button>
              <button (click)="incrementMin()"
                class="w-8 h-8 rounded-lg border border-white/[0.08] bg-white/[0.02] flex items-center justify-center text-text-muted hover:text-white hover:border-white/20 transition-colors"><svg
                  class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
                </svg></button>
            </div>
          </div>
        </div>

        <!-- Max Price -->
        <div
          class="border border-white/[0.08] rounded-[16px] p-5 bg-[#050505] focus-within:border-gold/30 transition-colors">
          <div class="flex items-center justify-between">
            <div class="flex-1">
              <div class="text-[12px] font-bold text-text-muted mb-2">Max price</div>
              <div class="mb-0.5">
                <input *ngIf="!isCalculatingRange" type="text" inputmode="decimal" [ngModel]="formatPlain(maxPrice)" (ngModelChange)="maxPrice = $event; onMaxPriceChange()" (keydown)="preventInvalidKeys($event)" (blur)="snapMaxPrice()"
                  (wheel)="preventScroll($event)"
                  class="bg-transparent text-[22px] font-black text-white outline-none w-full appearance-none">
                <div *ngIf="isCalculatingRange" class="w-2/3 h-8 bg-white/10 animate-pulse rounded mt-1 mb-1"></div>
              </div>
              <div class="text-[12px] font-bold text-text-muted mb-1.5"><ng-container
                  *ngIf="baseToken === 'from'">{{state.toToken()?.symbol || '...'}} per
                  {{state.fromToken().symbol}}</ng-container><ng-container
                  *ngIf="baseToken === 'to'">{{state.fromToken().symbol}} per {{state.toToken()?.symbol ||
                  '...'}}</ng-container></div>
              <div class="text-[11px] font-bold text-[#20d489]">+11.75%</div>
            </div>
            <div class="flex flex-col gap-2 shrink-0">
              <button (click)="decrementMax()"
                class="w-8 h-8 rounded-lg border border-white/[0.08] bg-white/[0.02] flex items-center justify-center text-text-muted hover:text-white hover:border-white/20 transition-colors"><svg
                  class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M20 12H4" />
                </svg></button>
              <button (click)="incrementMax()"
                class="w-8 h-8 rounded-lg border border-white/[0.08] bg-white/[0.02] flex items-center justify-center text-text-muted hover:text-white hover:border-white/20 transition-colors"><svg
                  class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
                </svg></button>
            </div>
          </div>
        </div>
      </div>


      <div class="mb-6">
        <h2 class="text-white text-[16.5px] font-bold mb-1">Deposit tokens</h2>
        <p class="text-[13px] text-text-muted">Specify the token amounts for your liquidity contribution.</p>
      </div>

      <!-- Token Inputs -->
      <div class="flex flex-col gap-2 mb-8">
        <!-- Token 1 Deposit -->
        <div *ngIf="!isToken1Disabled"
          class="flex flex-col gap-3 border border-white/[0.08] rounded-[16px] p-4 bg-[#050505] focus-within:border-gold/40 transition-colors group">
          <div class="flex items-center justify-between gap-4">
            <button
              class="flex items-center gap-2.5 px-2 py-1.5 hover:bg-white/5 rounded-xl transition-colors shrink-0">
              <div
                class="w-7 h-7 rounded-full flex items-center justify-center text-[10px] font-bold text-white border-2 border-black shadow-sm overflow-hidden"
                [style.backgroundColor]="state.fromToken().color">
                <img *ngIf="state.fromToken().logoUrl" [src]="state.fromToken().logoUrl" class="w-full h-full object-cover">
                <span *ngIf="!state.fromToken().logoUrl">{{state.fromToken().symbol.charAt(0)}}</span>
              </div>
              <span class="text-white font-bold text-[16px]">{{state.fromToken().symbol}}</span>
              <svg class="w-4 h-4 text-text-dim" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            <input type="text" inputmode="decimal" [(ngModel)]="depositToken1" (ngModelChange)="onDepositToken1Change()" (keydown)="preventInvalidKeys($event)"
              [disabled]="isToken1Disabled || isCalculatingRange" [class.opacity-50]="isToken1Disabled || isCalculatingRange" placeholder="0.0"
              (wheel)="preventScroll($event)"
              class="w-full bg-transparent text-right text-[22px] font-black text-white outline-none appearance-none flex-1 min-w-0">
          </div>
          <div class="flex items-center justify-between px-2">
            <div class="text-[12px] text-text-muted">$0.00</div>
            <div class="flex items-center gap-2.5">
              <span class="text-xs text-gray-400 font-medium">Balance: {{ state.isWalletConnected() ? state.getFormattedBalance(state.fromToken().address) : '--' }}</span>
              <button (click)="setMaxToken1()"
                class="px-2.5 py-1 text-[10.5px] font-bold text-gold border border-gold/30 bg-gold/5 rounded hover:bg-gold/10 transition-colors">MAX</button>
            </div>
          </div>
        </div>

        <!-- Token 2 Deposit -->
        <div *ngIf="!isToken2Disabled"
          class="flex flex-col gap-3 border border-white/[0.08] rounded-[16px] p-4 bg-[#050505] focus-within:border-gold/40 transition-colors group">
          <div class="flex items-center justify-between gap-4">
            <button *ngIf="state.toToken()"
              class="flex items-center gap-2.5 px-2 py-1.5 hover:bg-white/5 rounded-xl transition-colors shrink-0">
              <div
                class="w-7 h-7 rounded-full flex items-center justify-center text-[10px] font-bold text-white border-2 border-black shadow-sm overflow-hidden"
                [style.backgroundColor]="state.toToken()?.color">
                <img *ngIf="state.toToken()?.logoUrl" [src]="state.toToken()?.logoUrl" class="w-full h-full object-cover">
                <span *ngIf="!state.toToken()?.logoUrl">{{state.toToken()?.symbol?.charAt(0)}}</span>
              </div>
              <span class="text-white font-bold text-[16px]">{{state.toToken()?.symbol}}</span>
              <svg class="w-4 h-4 text-text-dim" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            <input type="text" inputmode="decimal" [(ngModel)]="depositToken2" (ngModelChange)="onDepositToken2Change()" (keydown)="preventInvalidKeys($event)"
              [disabled]="isToken2Disabled || isCalculatingRange" [class.opacity-50]="isToken2Disabled || isCalculatingRange" placeholder="0.0"
              (wheel)="preventScroll($event)"
              class="w-full bg-transparent text-right text-[22px] font-black text-white outline-none appearance-none flex-1 min-w-0">
          </div>
          <div class="flex items-center justify-between px-2">
            <div class="text-[12px] text-text-muted">$0.00</div>
            <div class="flex items-center gap-2.5">
              <span class="text-xs text-gray-400 font-medium">Balance: {{ state.isWalletConnected() ? state.getFormattedBalance(state.toToken()?.address) : '--' }}</span>
              <button (click)="setMaxToken2()"
                class="px-2.5 py-1 text-[10.5px] font-bold text-gold border border-gold/30 bg-gold/5 rounded hover:bg-gold/10 transition-colors">MAX</button>
            </div>
          </div>
        </div>
      </div>

      @if (!state.isWalletConnected()) {
      <button (click)="state.openConnectModal()"
        class="w-full btn-gold py-4 rounded-[12px] font-bold text-[15.5px] mb-4">Connect wallet</button>
      } @else {
      <button (click)="addLiquidity()" [disabled]="!getLiquidityValidationState().isValid || isSubmitting"
        [ngClass]="(!getLiquidityValidationState().isValid || isSubmitting) ? 'opacity-50 cursor-not-allowed grayscale' : 'hover:brightness-110'"
        class="w-full btn-gold py-4 rounded-[12px] font-bold text-[15.5px] mb-4 transition-all flex items-center justify-center gap-2">
        @if (isSubmitting) {
          <svg class="animate-spin -ml-1 mr-2 h-5 w-5 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Processing...
        } @else {
          {{ getLiquidityValidationState().message }}
        }
      </button>
      }
      <div class="text-center text-[12px] text-text-muted">By connecting your wallet, you agree to our <a href="#"
          class="text-gold hover:underline">Terms of Service</a>.</div>

    </div>

  </div>
</section>

<!-- ═══════════════ MODAL: LOCAL TOKEN SELECTOR ═══════════════ -->
@if (showLocalTokenModal) {
<div class="modal-overlay" (click)="closeLocalModal()">
  <div class="modal-panel animate-slide-up" (click)="$event.stopPropagation()">
    <button (click)="closeLocalModal()"
      class="absolute top-5.5 right-5.5 text-text-dim hover:text-white transition-colors text-lg">✕</button>

    <h3 class="font-display font-black text-2xl text-white tracking-wide mb-1">Select an Asset</h3>
    <p class="text-[11.5px] text-text-dim uppercase tracking-wider font-semibold mb-5">Choose from verified assets</p>

    <!-- Search Field -->
    <div
      class="bg-black/45 border border-border-primary focus-within:border-gold/30 rounded-2xl p-3.5 flex items-center gap-3 mb-5 transition-all">
      <svg class="w-4.5 h-4.5 text-text-dim" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
      </svg>
      <input type="text" placeholder="Search by name or symbol..." [value]="localTokenSearchQuery"
        (input)="localTokenSearchQuery = $any($event.target).value"
        class="bg-transparent text-white text-[13.5px] outline-none w-full placeholder-text-dim font-medium" />
    </div>

    <!-- Scrollable Asset items -->
    <div class="flex flex-col gap-1.5 max-h-64 overflow-y-auto pr-1">
      @for (token of filteredLocalTokens; track token.symbol) {
      <button type="button" (click)="selectLocalToken(token)"
        class="flex items-center justify-between p-3 hover:bg-white/[0.03] rounded-xl text-left border border-transparent hover:border-border-primary transition-all">
        <div class="flex items-center gap-3">
          <div class="token-badge flex items-center justify-center font-bold text-white border-2 border-black overflow-hidden w-8 h-8 rounded-full"
            [style.background]="token.color || '#2775ca'">
            <img *ngIf="token.logoUrl" [src]="token.logoUrl" class="w-full h-full object-cover">
            <span *ngIf="!token.logoUrl">{{ token.symbol.charAt(0) }}</span>
          </div>
          <div>
            <p class="font-extrabold text-[13.5px] text-white tracking-wide leading-none">
              {{ token.symbol }}
            </p>
            <p class="text-[10px] text-text-dim mt-1 font-medium">{{ token.name }}
              @if (token.address) {
              <span class="text-text-dim text-[11px] ml-1 font-normal">{{ token.address.substring(0, 6) }}...{{
                token.address.substring(token.address.length - 4) }}</span>
              }
            </p>
          </div>
        </div>
        <!-- <div class="text-right">
          <p class="text-[13.5px] font-bold text-white">${{ token.rate.toLocaleString('en-US', {
            minimumFractionDigits: 2, maximumFractionDigits: 4 }) }}</p>
        </div> -->
      </button>
      } @empty {
      <div class="text-center py-8 text-text-dim text-[12px] font-bold uppercase tracking-wider">No matching assets
        found.</div>
      }
    </div>
  </div>
</div>
}

<!-- Full Screen Overlay -->
<div *ngIf="isSubmitting" class="fixed inset-0 z-[9999] bg-black/60 backdrop-blur-sm flex flex-col items-center justify-center pointer-events-auto">
  <div class="bg-[#0c0c0c] border border-white/10 rounded-2xl p-8 max-w-sm w-full mx-4 shadow-[0_0_50px_rgba(245,183,59,0.15)] flex flex-col items-center text-center">
    <div class="relative w-16 h-16 mb-6">
      <div class="absolute inset-0 border-4 border-white/10 rounded-full"></div>
      <div class="absolute inset-0 border-4 border-gold rounded-full border-t-transparent animate-spin"></div>
    </div>
    <h3 class="text-white text-[18px] font-bold mb-2 tracking-wide">Transaction Pending</h3>
    <p class="text-text-muted text-[13.5px] leading-relaxed">Please wait while your transaction is confirmed on the blockchain. Do not close this page.</p>
  </div>
</div>